import { render, staticRenderFns } from "./MyTemplate.vue?vue&type=template&id=6acf79cd&scoped=true"
import script from "./MyTemplate.vue?vue&type=script&lang=js"
export * from "./MyTemplate.vue?vue&type=script&lang=js"
import style0 from "./MyTemplate.vue?vue&type=style&index=0&id=6acf79cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acf79cd",
  null
  
)

export default component.exports